// import Swiper JS



// Test
//import 'jquery-migrate';
//import 'bootstrap/js/dist/alert';
//import 'bootstrap/js/dist/button';

//import  'bootstrap/js/dist/alert';
//import  'bootstrap/js/dist/button';
//import  'bootstrap/js/dist/collapse';
//import  'bootstrap/js/dist/dropdown';
//import  'bootstrap/js/dist/modal';
//import  'bootstrap/js/dist/offcanvas';
//import  'bootstrap/js/dist/popover';
//import  'bootstrap/js/dist/scrollspy';
//import  'bootstrap/js/dist/tab';s
//import  'bootstrap/js/dist/toast';
// jQuery & Migrate
import 'bootstrap/js/dist/tooltip';



// Joomla Core
// Polyfills
//import '../../../../media/vendor/es-module-shims/js/es-module-shims';
//import '../../../../media/vendor/webcomponentsjs/js/webcomponents-bundle';

// Accessibility
//import '../../../../media/vendor/accessibility/js/accessibility';


$(document).ready(function () {


    var tooltipContent = `<div id="oppening-time">
                                    <div><div>Montag:</div> <span>08:30–12:30, 14:00–18:00</span></div>
                                    <div><div>Dienstag:</div> <span>08:30–12:30, 14:00–18:00</span></div>
                                    <div><div>Mittwoch:</div> <span>08:30–13:00, 14:00–18:00</span></div>
                                    <div><div>Donnerstag:</div> <span>08:30–12:30, 14:00–18:00</span></div>
                                    <div><div>Freitag:</div> <span>Nach Vereinbarung</span></div>
                                  </div>`;

    // Tooltip-Daten dynamisch zum Element hinzufügen
    $('#tooltip-opentimes')
        .attr('data-bs-toggle', 'tooltip')
        .attr('data-bs-html', 'true')
        .attr('title', tooltipContent);

    // Tooltip aktivieren
    $('#tooltip-opentimes').tooltip({
        placement: 'bottom',
        trigger: 'hover focus click',
        customClass: 'custom-tooltip'
    });
    $('.dt-nav-m,.side-cta').click(function() {
        var url = $('#doctolib-custom a').attr('href');
        if (url) {
            window.open(url, '_blank');
        }
    });

});